import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

/**
 * IcPinComponent renders a pin icon with optional gradient.
 */
@Component({
  selector: 'ic-pin',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ic-pin.html',
})
export class IcPinComponent {
  /** The starting color of the icon gradient. */
  @Input() startColor: string | null = null;

  /** The ending color of the icon gradient. */
  @Input() endColor: string | null = null;

  /** The opacity of the icon. Defaults to 0.6. */
  @Input() opacity = 0.6;

  /** The width of the icon. Defaults to 12. */
  @Input() width: number | string = 12;

  /** The height of the icon. Defaults to 19. */
  @Input() height: number | string = 19;

  /** Default color used when no gradient is provided. */
  @Input() defaultColor = '#B8C0C6';

  /** Unique ID for the SVG gradient to avoid collisions. */
  gradientId = `pinGradient-${Math.random().toString(36).slice(2)}`;

  /** Checks if both startColor and endColor are provided and non-empty. */
  get hasGradient(): boolean {
    return (
      typeof this.startColor === 'string' &&
      typeof this.endColor === 'string' &&
      this.startColor.trim() !== '' &&
      this.endColor.trim() !== ''
    );
  }
}
